import React from "react";
import {Container, Section, TextContainer, ImageContainer} from "./styles"
import {LargeHeading, Paragraph} from "../../../../lib/Font/styles"
import EastOrWestButton from "../../../base/Buttons/EastOrWestButton/EastOrWestButton";
import { COLORS } from "../../../../values/colors";
import { middleLeftAnimationProps, middleRightAnimationProps } from "../../../functionallity/animationProps";
import { useNavigate } from 'react-router-dom';

const OverviewContainer: React.FC = () => {
  const navigate = useNavigate();
    return (
      <Container>
        <Section>
          <TextContainer {...middleLeftAnimationProps}>
            <LargeHeading lang="de">ECKENMOORHEXEN - SEIT 2011.</LargeHeading>
            <Paragraph color={COLORS.textSecondary}>
            Die Eckenmoorhexen Sulgen e.V. sind ein Fasnetsverein aus Schramberg im Schwarzwald, der seit 2011 besteht.
             Gegründet wurde er von Dominik Fix, Yvonne Özer und fünf weiteren Fasnetsbegeisterten. 
             Mittlerweile zählt der Verein über 70 aktive Mitglieder, die während der Fasnetszeit mit ihren Hexenkostümen und 
             Auftritten die Tradition hochhalten. Ob bei Umzügen oder Veranstaltungen in der Region – die Eckenmoorhexen sorgen jedes
              Jahr für Stimmung und sind ein fester Teil der schwäbisch-allemanischen Fasnet. 
            </Paragraph>
            <EastOrWestButton text="Mehr erfahren" east={true} enabled={true} onClick={() => navigate('/ueber-uns')}/>
          </TextContainer>
          <ImageContainer {...middleRightAnimationProps}>
            <img src={require('../../../../assets/images/Home/groupPic_2025.jpg')} alt="Group of people in front of a trailer" />
          </ImageContainer>
        </Section>
        
        <Section reverse>
          <TextContainer {...middleRightAnimationProps}>
          <LargeHeading lang="de">DIE GESCHICHTE.</LargeHeading>
            <Paragraph color={COLORS.textSecondary}>
            Auf den Höhen Schrambergs lebte einst der Schweinezüchter Karl, geschätzt und geachtet in den Dörfern Sulgen und Sulgau.
             Doch eine düstere Nacht und ein unheimlicher Vorfall im Eckenwald veränderten alles. 
             Was damals geschah, sollte Karl und das ganze Umland nie wieder loslassen – eine Sage über Rache, 
             Hexen und das unheimliche Moor begann. Wer sind die Eckenmoorhexen, und warum treiben sie zur Fasnet ihr Unwesen? 
             Die Geschichte erzählt von einem dunklen Geheimnis, das bis heute die Menschen fasziniert und erschauern lässt… 
            </Paragraph>
            <EastOrWestButton text="Mehr erfahren" east={true} enabled={true} onClick={() => navigate('/die-geschichte')}/>
          </TextContainer>
          <ImageContainer {...middleLeftAnimationProps}>
            <img src={require('../../../../assets/images/Home/ceremony.png')} alt="Group of people in witch costume" />
          </ImageContainer>
        </Section>
        
        <Section>
          <TextContainer {...middleLeftAnimationProps}>
          <LargeHeading lang="de">DAS KLEIDLE.</LargeHeading>
            <Paragraph color={COLORS.textSecondary}>
            Das Kleidle der Eckenmoorhexen ist mehr als ein Fasnetskostüm – es trägt die Geschichte des „Moorenkarle“ und seiner Hexen in
             jedem Detail. Von den erdigen Farben des Moores bis hin zu den wilden Symbolen des Eckenwaldes spiegelt es die Legende wider,
              die hinter den Eckenmoorhexen steckt. Auf dieser Seite zeigen wir das Hexengewand und erklären die Bedeutung der einzelnen
               Elemente. Erlebt die Faszination, die dieses traditionelle Kleidle ausmacht, und entdeckt, was die Eckenmoorhexen bei
                jedem Auftritt lebendig werden lassen. 
            </Paragraph>    
            <EastOrWestButton text="Mehr erfahren" east={true} enabled={true} onClick={() => navigate('')}/>
          </TextContainer>
          <ImageContainer {...middleRightAnimationProps}>
            <img src={require('../../../../assets/images/Home/smokingWitch.png')} alt="Witch with green smoke" />
          </ImageContainer>
        </Section>
      </Container>
    );
  };
  
  export default OverviewContainer;